// La nouvelle interface, épurée (9 octobre 2026) : la liste des formats de
// Projector, la page d'un format, son brief, ses documents, son écoute et la
// synthèse de ses derniers résultats. Les mots du métier déjà écrits
// (`projector.etape`, `projector.formats.champ`…) se lisent dans `projector`.
export default {
  liste: {
    titre: 'Formats',
    sousTitre: 'Chaque format monte l’escalier des preuves, du texte à l’antenne',
    nouveau: 'Nouveau format',
    compte: 'Aucun format | {n} format | {n} formats',
    tableau: 'Les formats',
    col: {
      format: 'Format',
      diffuseur: 'Diffuseur',
      cibles: 'Cibles',
      avancement: 'Avancement',
      resultat: 'Dernier résultat',
      maj: 'Mis à jour',
    },
    par: 'par {nom}',
    avancementAria: 'Marches testées : {n} sur {sur}',
    aucun: 'Aucun format pour l’instant',
    aucunTexte: 'Un format se dépose avec son brief, et le titre suffit pour commencer. Son escalier commence au format papier.',
    pasTeste: 'Pas encore testé',
    illisible: 'Illisible pour l’instant',
    testEnCours: 'un test en cours',
    sansDiffuseur: 'Pas encore de destination',
    sansCible: 'Non précisées',
  },
  marche: {
    brief: 'les publics à interroger',
    format_papier: 'l’envie de regarder, par cible',
    ab: 'la version qui l’emporte : texte, visuel ou talent',
    dossier: 'la variante qui gagne',
    visuel: 'l’adhésion à l’univers',
    casting: 'l’effet talent',
    pilote: 'les décrochages',
    episode: 'la rétention, les moments forts, le ressenti',
    lancement: 'la part d’audience projetée',
    sortie: 'qui le regarderait dès sa sortie',
    export: 'l’envie, pays par pays',
  },
  // Les confirmations (15 octobre 2026).
  confirmer: {
    archiver: {
      titre: 'Archiver « {titre} » ?',
      texte: 'Le format quitte la liste et le menu des dossiers, et ne se teste plus. Ses études restent lisibles.',
    },
  },
  brief: {
    // Les étapes de la fenêtre du brief (15 octobre 2026).
    pas: {
      essentiel: 'L’essentiel',
      diffusion: 'La diffusion',
      antenne: 'Ses rendez-vous',
      cibles: 'Cibles et écriture',
      visuel: 'Le visuel',
    },
    // Déjà à l'antenne (19 octobre 2026) : ses rendez-vous, lus dans la grille de la chaîne.
    antenne: {
      case: 'Déjà à l’antenne',
      caseAide: 'Il se suit : ses rendez-vous dans la grille de la chaîne, chaque passage et son audience.',
      seulementChaine: 'Le suivi à l’antenne se fait sur une chaîne : choisissez-en une.',
      choisir: 'Ses rendez-vous sur {chaine}',
      recherche: 'Lecture de la grille de {chaine}…',
      erreur: 'La grille ne s’est pas lue.',
      relire: 'Relire la grille',
      aucun: 'Aucun rendez-vous de « {titre} » dans la grille de {chaine} ces trois dernières semaines ni la semaine à venir. Vérifiez le titre tel que la chaîne l’écrit.',
      auMoinsUn: 'Cochez au moins un rendez-vous à suivre.',
      prochain: 'Prochain passage : {quand}',
      derniere: 'Dernière audience : {telespectateurs} téléspectateurs ({pda})',
      passes: 'Aucun passage ces trois dernières semaines | Un passage ces trois dernières semaines | {n} passages ces trois dernières semaines',
    },
    creerMaintenant: 'Créer maintenant',
    aide: 'Le titre suffit pour commencer ; le reste se complète quand vous le savez.',
    visuelAide: 'JPEG, PNG ou WebP, 12 Mo au plus.',
  },
  documents: {
    aide: 'Ce que vous savez déjà de ce format : études, sondages, notes, audiences. Orion s’en sert pour lire le format ; le panel ne les lit jamais. Les chiffres lus attendent votre validation.',
    texte: 'Le texte',
  },
  ecoute: {
    aide: 'Ce que le format provoque en ligne : le ton de ce qui se dit, les 4R, ce que les gens écrivent et qui en parle.',
    pasDiffuse: 'Ce format n’est pas encore passé à l’antenne : il s’écoutera après sa première diffusion.',
    polarite: 'Le ton',
    quatreR: 'Les 4R',
    mentions: 'Ce qu’ils écrivent',
    quiEnParle: 'Qui en parle',
    // L'écoute versionnée, planifiée et nourrie du terrain (20 octobre 2026).
    version: 'Écoute n° {n} du {le}',
    periode: 'lit du {debut} au {fin}',
    periodeTout: 'lit tout ce qui s’en est dit jusqu’au {fin}',
    prochaine: 'prochaine écoute le {le}',
    versions: '{n} écoutes',
    nouvelleEnCours: 'Une nouvelle écoute est en cours : celle-ci reste affichée jusqu’à ce qu’elle finisse.',
    consultee: 'Vous consultez l’écoute n° {n}, une écoute d’avant.',
    revenir: 'Revenir à cette écoute',
    retourCourante: 'Retour à l’écoute actuelle',
    consulter: 'Consulter',
    courante: 'affichée',
    mentionsN: 'aucune mention | {n} mention | {n} mentions',
    avecTerrain: 'avec le terrain',
    passeEchec: 'n’a rien rendu',
    declencheur: { manuel: 'à la demande', apres_prime: 'après un prime', planifie: 'planifiée', ouverture: 'relancée', reprise: 'première écoute' },
    cadence: { libelle: 'Écoute automatique', aucune: 'Pas d’écoute automatique', quotidienne: 'Chaque jour', hebdo: 'Chaque semaine', mensuelle: 'Chaque mois' },
    terrain: {
      titre: 'Ce que rapportent nos jumeaux du terrain',
      provenance: 'Terrain des jumeaux',
      ou: 'Surtout à : {ou}',
      avis: 'Les avis : {avis}',
    },
  },
  resultat: {
    regarderaient: 'le regarderaient',
    regarderaientCibles: 'le regarderaient sur vos cibles',
    aucuneDevant: 'Aucune version ne se détache',
    lEmporte: '« {nom} » l’emporte',
    devanceDePeu: '« {nom} » devance de peu',
    jusquAuBout: 'regardent jusqu’au bout',
    partProjetee: 'de part d’audience projetée',
    partSimulee: 'de part d’audience simulée',
    premiereSemaine: 'le regarderaient dans sa première semaine',
    sortieLe: 'Sur {plateforme} le {jour}',
    personnes: '{valeur} personnes{bornes}',
    export: 'Format {verdict}',
    detail: 'Le détail',
    luLe: 'lu le {jour}',
    indifferents: '{pct} d’indifférents',
    rang: '{rang} sur {sur} face à ses comparables, lus à l’aveugle',
    projectionClasse: 'Projection par la classe : {pda} de part d’audience{bornes}.',
    surCibles: 'Le regarderaient, sur vos cibles : {cibles}',
    surEnsemble: 'Le regarderaient, sur l’ensemble du panel',
    choisissentCibles: 'Vues côte à côte, la part qui choisit chaque version, sur vos cibles : {cibles}',
    choisissentEnsemble: 'Vues côte à côte, la part qui choisit chaque version, sur l’ensemble du panel',
    telespectateurs: '{valeur} téléspectateurs{bornes}',
    rienALire: 'Rien de lisible dans ce résultat.',
    aussiSur: 'Lu aussi sur : {cibles}. Le détail est sur la page du test.',
    partiel: 'Résultat partiel : une version n’a pas répondu.',
  },
  format: {
    titreAttente: 'Format',
    sousTitre: 'Marches testées : {n} sur {sur}',
    ariane: 'Fil d’Ariane',
    introuvable: 'Ce format est introuvable.',
    retourListe: 'Revenir aux formats',
    brief: 'Le brief',
    cibles: 'Cibles : {cibles}',
    adapteDe: 'Adapté de : {pays}',
    premiereLe: 'Première diffusion le {jour}',
    premiereARenseigner: 'Date de première à renseigner',
    partage: {
      prive: 'visible de son auteur seul',
      equipe: 'partagé avec l’équipe',
      personnes: 'partagé avec {n} personne | partagé avec {n} personne | partagé avec {n} personnes',
      choisies: 'partagé avec des personnes choisies',
    },
    modifierBrief: 'Modifier le brief',
    escalierDe: 'L’escalier de {titre}',
    etNouvelleLecture: '{resultat} · une nouvelle lecture en cours',
    enCours: 'En cours',
    manqueSoiree: 'La date de première ou la case n’est pas renseignée.',
    manqueSortie: 'La date de sortie n’est pas renseignée.',
    completerBrief: 'Compléter le brief',
    voirLesTests: 'Voir les {n} tests | Voir le test | Voir les {n} tests',
    derniersResultats: 'Les derniers résultats',
  },
  // Les documents et l'écoute d'un format, sortis des onglets de la Fiche pour la barre (10 octobre 2026).
  marche_page: {
    sousTitre: '{titre} · {n} test | {titre} · {n} test | {titre} · {n} tests',
    rend: 'Ce que cette marche rend : {sortie}.',
    tableau: 'Les tests de la marche',
    aucun: 'Aucun test sur cette marche pour l’instant.',
    sansResultat: 'Pas encore de résultat',
    col: { test: 'Test', resultat: 'Résultat', etat: 'État', quand: 'Par, le' },
  },
  section: {
    documents: { titre: 'Documents', sousTitre: 'Les documents déposés sur {titre}' },
    ecoute: { titre: 'Écoute', sousTitre: 'Ce qui se dit de {titre} depuis sa diffusion' },
    suivi: { titre: 'Suivi', sousTitre: '{titre} à l’antenne, passage après passage' },
  },
  genre: { prime: 'Prime', quotidienne: 'Quotidienne', autre: 'Autre rendez-vous' },
  jours: { tous: 'tous les jours', seul: 'le {jour}', plage: 'du {de} au {a}', aHeure: '{jours} à {heure}', et: 'et' },
  suivi: {
    panneau: '{titre} à l’antenne',
    aide: 'Chaque passage de ses rendez-vous sur {chaine} et son audience, relevée le lendemain matin.',
    aideSansChaine: 'Chaque passage de ses rendez-vous et son audience, relevée le lendemain matin.',
    pasALAntenne: 'Ce format n’est pas suivi à l’antenne. Dans son brief, cochez « Déjà à l’antenne » sur sa chaîne et choisissez ses rendez-vous.',
    erreur: 'Le suivi ne s’est pas lu.',
    modifier: 'Ses rendez-vous',
    relever: 'Relever maintenant',
    releveEnCours: 'Relevé des audiences en cours',
    prochain: 'Prochain passage',
    dernier: 'Dernier passage',
    evolution: 'Par rapport au précédent',
    face: 'face à {quand} ({telespectateurs})',
    unSeul: 'Il faut deux passages mesurés.',
    moyenne: 'Moyenne des {n} derniers',
    moyenneSans: 'Moyenne',
    telespectateursPart: 'téléspectateurs, {pda} de part d’audience',
    points: '{v} pt de part d’audience',
    barresAria: 'Audience de {titre}, {n} passages, en millions de téléspectateurs',
    enMillions: 'En millions de téléspectateurs de 4 ans et plus.',
    passes: 'Passages',
    aVenir: 'À venir',
    aucunPassage: 'Aucun passage de ce rendez-vous ces huit dernières semaines.',
    attendue: 'Audience publiée demain matin',
    enAttente: 'Audience à relever',
    introuvable: 'Audience pas encore publiée',
    article: 'Article',
    col: { quand: 'Passage', telespectateurs: 'Téléspectateurs', pda: 'Part d’audience', cibles: 'Cibles', source: 'Source', lecture: 'Lecture' },
    lecture: 'Lire',
    voirLecture: 'Voir la lecture',
    masquerLecture: 'Masquer la lecture',
    projeter: 'Projeter ce passage',
    // La projection d'Orion d'un prime (21 octobre 2026), en rappel.
    projection: {
      tete: 'Projection d’Orion : {part}',
      rejouee: 'Rejouée après la diffusion : {part}',
      part: '{pct} ({bas} ~ {haut} %)',
      telespectateurs: '{n} téléspectateurs',
      mesure: 'mesuré {pda}, écart {ecart}',
      seconde: '2e partie : {part}',
      voirTest: 'Voir le test',
      scellee: 'Scellée le {quand}',
      voirEnveloppe: 'Voir l’enveloppe',
      auto: 'Projection de la veille',
      jumeaux: 'Jumeaux seuls : {pct}',
      concurrents: 'Les autres chaînes, projetées',
    },
    // Les projections faites seules la veille de chaque passage (27 octobre 2026).
    auto: {
      titre: 'Projeter chaque passage la veille',
      aide: 'Chaque passage se projette la veille à partir de 14 h et se scelle avant l’antenne ; sa mesure s’y confronte le lendemain.',
      active: 'Activées par {qui}',
      activer: 'Activer',
      couper: 'Couper',
    },
  },
  // La lecture d'un passage (19 octobre 2026).
  lecture: {
    titre: 'Pourquoi : {passage}',
    aide: 'Ce qui s’est dit avant, pendant et après la diffusion, la concurrence de la soirée, et ce que vous pouvez tester ensuite.',
    erreur: 'La lecture ne s’est pas lue.',
    enCours: 'Lecture en cours : ce qui s’est dit, puis pourquoi. Quelques minutes.',
    echec: 'La lecture de ce passage a échoué.',
    pasEncore: 'Ce passage n’est pas encore lu.',
    pasDiffuse: 'Ce passage n’est pas encore diffusé.',
    lire: 'Lire ce passage',
    relire: 'Relire',
    fermer: 'Fermer',
    pourquoi: 'Pourquoi',
    force: { forte: 'raison forte', moyenne: 'raison moyenne', faible: 'raison faible' },
    detail: 'Voir le détail',
    masquer: 'Masquer',
    ceQuiSestDit: 'Ce qui s’est dit',
    courbeAria: 'La conversation sur X, heure par heure : {avant} messages avant, {pendant} pendant, {apres} après',
    pic: 'pic à {heure} : {n} messages',
    fenetre: { avant: 'Avant', pendant: 'Pendant', apres: 'Après' },
    surX: '{n} sur X',
    ton: '{favorable} en bien, {defavorable} en mal',
    intention: { regarde_aime: 'regarde et aime', regarde_deteste: 'regarde en râlant', decroche: 'décroche', indifferent: 'sans avis' },
    rienLu: 'Rien de lu dans cette fenêtre.',
    moments: 'Ce qui a fait parler',
    concurrence: 'La concurrence ce soir-là',
    pistes: 'À tester ensuite',
    genre: { sonar: 'Sonar', ab: 'A/B' },
    question: 'La question :',
    preparer: { sonar: 'Préparer ce Sonar', ab: 'Préparer cet A/B' },
    lancee: { a_lancer: 'Préparé le {quand}, pas encore lancé', en_cours: 'Lancé le {quand}, en cours', pret: 'Résultats prêts', echec: 'En échec' },
    voir: { sonar: 'Voir le Sonar', ab: 'Voir le test' },
    repreparer: 'Préparer à nouveau',
    personas: 'Ceux qui en ont parlé',
    origine: 'les gens qui ont parlé de {passage}',
  },
}
